/**
 * Pages that only make sense with the link that opened them (a code in the #fragment or the
 * query string). Never remembered as the "last page visited" and never restored on a fresh
 * tab: reopened without their link they show "This link is not valid" (27 Oct 2026: a paid
 * sale's Welcome link set the password, went to Home, and the restore sent it back to /verify).
 */
export const ONE_TIME_ROUTES = [
  '/verify',
  '/reset-password',
  '/forgot-password',
  '/invitations/accept',
  '/unsubscribe',
  '/rsvp',
];

export function isOneTimeRoute(pathname: string): boolean {
  return ONE_TIME_ROUTES.some((r) => pathname === r || pathname.startsWith(r + '/'));
}
